

























































// Vue
import { Component, Vue } from 'vue-property-decorator'

// Components
import { DataTable } from '../../table'
import { IsActive } from '@/components'

// services
import { AreaService } from '@/services/config'

// Models
import { Paginator } from '@/models'
import { AreaModel } from '@/models/config'

@Component({
    name: 'TableListCostCenter',
    components: {
        DataTable,
        IsActive
    }
})
export default class TableListCostCenter extends Vue {
    loading = false
    items: [AreaModel] | [] = []
    pagination: Paginator = {
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    }

    fields = [
        {
            key: 'name',
            sortable: true,
            label: 'Nombre'
        },
        {
            key: 'description',
            sortable: true,
            label: 'Descripción'
        },
        {
            key: 'centro',
            sortable: true,
            label: 'Centro de Costo'
        },
        {
            key: 'status_text',
            sortable: true,
            label: 'Status'
        },
        {
            key: 'actions',
            sortable: false,
            label: '',
            thClass: 'one-line w-30',
            thStyle: {
                width: '15%'
            }
        }
    ]

    created () {
        this.getAreasWithPagination()
    }

    changePage (page: number) {
        this.pagination.currentPage = page
        this.getAreasWithPagination()
    }

    changePerPage (perPage: number) {
        this.pagination.perPage = perPage
        this.pagination.currentPage = 1
        this.getAreasWithPagination()
    }

    async getAreasWithPagination () {
        this.loading = true
        const response = await AreaService.getWithPagination(this.pagination.perPage, this.pagination.currentPage)
        this.items = response.objects
        this.pagination = response.pagination
        this.loading = false
    }
}
